import { useNavigate } from "react-router-dom"
import { useAppContext } from "../../context/AppState/AppContext"
import { useState, useEffect } from "react"
import { calculatePrice } from "../../utils/calculatePrice"
import axios from "axios"
import { Loader } from "@mantine/core"
import { IconBrandWhatsapp } from "@tabler/icons-react"
import showNotification from "../../utils/showNotification"



const FreePricingCardInfo = {
    features: [
        'Acceso al grupo de debate en Whatsapp',
        'Mapa de realidades',
        '1 caso clínico mensual',
    ],
    name: "Comunidad",
    description: "Para veterinarios que quieren empezar a pensar en colectivo.",
}



const PricingCard = ({ isFeatured, content, btxText = "Quiero ser parte", onClick, children }) => {

    const { isUSD, officialUSDValue } = useAppContext()


    const className = isFeatured ? "membership-card featured" : "membership-card"

    return <div className={className}>
        {isFeatured && <div className="mc-popular">Más elegido</div>}
        <div className="mc-name">{content?.name}</div>
        <div className="mc-desc">{content?.description}</div>
        <div className="mc-price"> {content?.price
            ? new Intl.NumberFormat('es-AR', {
                style: 'currency',
                currency: isUSD ? 'USD' : 'ARS',
                minimumFractionDigits: 0,
            }).format(calculatePrice(content?.price, officialUSDValue, isUSD))
            : "Gratis"}{content?.price && <span>/mes</span>}
            {!isUSD && content?.price && <div style={{ fontSize: "var(--fs-tiny)", color: "var(--color-text-secondary)", backgroundColor: "var(--color-text-primary)", width: 'max-content', padding: '.3rem .5rem', borderRadius: '50px' }}>${content.price.usd} USD</div>}
        </div>

        {/* <div className="mc-billing">Facturado anualmente</div> */}
        <ul className="mc-features">

            {content?.features?.map(item => (
                <li><span className="mc-check">✓</span> {item}</li>
            ))}

        </ul>

        {onClick && <button onClick={onClick} className="mc-btn primary">{btxText}</button>}
        {children}
    </div>
}

export default function SubscriptionPricingContent({ subscriptions, isLoading, onInscription }) {
    return <section className="membership section-wrapper">
        <div className="section-inner">
            {isLoading
                && <div style={{ height: '100%', width: '100%', display: 'grid', placeItems: "center" }}>
                    <Loader />
                </div>}
            <div className="membership-grid" style={{ gridTemplateColumns: `repeat(${(subscriptions?.length || 0) + 1}, 1fr)` }}>
                <PricingCard content={FreePricingCardInfo} children={
                    <a
                    href="https://link.forvet.org/sumate-a-la-comunidad-cp"
                    target="_blank"
                    className="mc-btn outline">Unirme gratis <IconBrandWhatsapp />
                </a>} />
                {(subscriptions && subscriptions?.length > 0) && subscriptions?.map(item => (
                    <PricingCard
                       key={item._id}
                       content={item}
                       isFeatured={item.is_featured}
                       onClick={() => onInscription(item)}
                    />
                ))}
            </div>
        </div>
    </section>
}